(function () {
    document.addEventListener("DOMContentLoaded", function () {


        initSection({
            holderId: "announcement-bar-holder",
            sectionName: "custom-announcement-bar",
            containerId: "announcement-bar-container",
        });

        if(window.location.pathname === "/") {
            initSection({
                holderId: "uhb-holder",
                sectionName: "under-hero-benefits",
                containerId: "under-hero-benefits-container",
            });
        }

        if (window.location.pathname.includes("/products/")) {
      
            initSection({
                holderId: "product-page-points-holder",
                sectionName: "product-page-points",
                containerId: "product-page-points-container",
            });

            initSection({
                holderId: "product-fit-gauge-holder",
                sectionName: "product-fit-gauge",
                containerId: "product-fit-gauge-container"
            });

            initSection({
                holderId: "product-page-shipping-holder",
                sectionName: "product-page-shipping",
                containerId: "product-page-shipping-container"
            });

            initSection({
                holderId: "tp-product-review-holder",
                sectionName: "tp-product-review",
                containerId: "tp-product-review-container"
            });

             initSection({
                holderId: "tiered-holder",
                sectionName: "tiered-discount-block",
                containerId: "tiered-discount-block-container"
            });

            initSection({
                holderId: "stock-holder",
                sectionName: "stock-count",
                containerId: "stock-count-container"
            });


            initSection({
                holderId: "product-bundle-savings-holder",
                sectionName: "product-bundle-savings",
                containerId: "product-bundle-savings-container"
            });
        }

        if (window.location.pathname.includes("/cart")) {
            initSection({
                holderId: "cart-page-points-holder",
                sectionName: "cart-page-points",
                containerId: "cart-page-points-container"
            });
            initSection({
                holderId: "cart-reserved-holder",
                sectionName: "cart-reserved-timer",
                containerId: "cart-reserved-container",
                afterInject: initCartReservedTimer
            });
        }
    });

    /* -------------------------------------------
       GENERIC LOADER
    --------------------------------------------*/

     function initSection({
        holderId,
        sectionName,
        containerId,
        afterInject
    }) {
        let loaded = false;

        function checkInitValue() {
            const initValue = sessionStorage.getItem("initValue");

            if ((initValue === "111D" || initValue === "110wacD") && !loaded) {
                loaded = true;

                fetch(window.location.pathname + "?sections=" + sectionName)
                    .then((res) => res.json())
                    .then((data) => {
                        if (!data[sectionName]) return;

                        const holder = document.getElementById(holderId);
                        if (!holder) return;

                        holder.innerHTML = data[sectionName];

                        const block = document.getElementById(containerId);

                        console.log("reached block")
                        console.log("block")

                        if (block) block.style.display = "block";

                        if (typeof afterInject === "function") {
                            afterInject();
                        }
                    });
            } else if (initValue === null) {
                setTimeout(checkInitValue, 100);
            }
        }

        checkInitValue();
    }
})();

function watchDOM(callback) {
    const observer = new MutationObserver(function () {
        callback();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
}

let cartTimerInterval;

function initCartReservedTimer() {
    if (cartTimerInterval) clearInterval(cartTimerInterval);

    const container = document.getElementById("cart-reserved-container");
    const timerEl = document.getElementById("cart-reserved-timer");

    if (!container || !timerEl) return;

    const minutes = parseInt(container.dataset.minutes || "9", 10);
    let countdown = minutes * 60;

    function updateTimer() {
        const m = Math.floor(countdown / 60);
        const s = countdown % 60;

        timerEl.textContent = `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;

        if (countdown > 0) {
            countdown--;
        } else {
            clearInterval(cartTimerInterval);
            container.style.display = "none";
        }
    }

    updateTimer();
    cartTimerInterval = setInterval(updateTimer, 1000);
}
